import client from "../Client/HttpClient";
import { IPreschoolPerformancePeriodAssignmentsModel} from "@/interfaces/modules";

const ApiPath = "PreschoolPerformancePeriodAssignments";

export default {
  /** GET api/PreschoolPerformancePeriodAssignments */
  GetAll: (): Promise<IPreschoolPerformancePeriodAssignmentsModel[]> =>
    client.get(`${ApiPath}`),

  /** GET api/PreschoolPerformancePeriodAssignments/{id} */
  GetById: (id: number): Promise<IPreschoolPerformancePeriodAssignmentsModel> =>
    client.get(`${ApiPath}/${id}`),

  /** GET api/PreschoolPerformancePeriodAssignments/byPerformance/{performanceId} */
  GetByPerformanceId: (performanceId: number): Promise<IPreschoolPerformancePeriodAssignmentsModel[]> =>
    client.get(`${ApiPath}/byPerformance/${performanceId}`),

  /** GET api/PreschoolPerformancePeriodAssignments/byPeriod/{periodId} */
  GetByPeriodId: (periodId: number): Promise<IPreschoolPerformancePeriodAssignmentsModel[]> =>
    client.get(`${ApiPath}/byPeriod/${periodId}`),

  /** POST api/PreschoolPerformancePeriodAssignments */
  Post: (data: IPreschoolPerformancePeriodAssignmentsModel): Promise<IPreschoolPerformancePeriodAssignmentsModel> =>
    client.post(`${ApiPath}`, data),
};
